export const AUTH_TOKEN_KEY = 'TOKEN';
export const USER_KEY = 'USER';
